import React from "react";
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";
import { Form } from "react-bootstrap";

export default function AddressAutoComplete(props) {
  const { addressInput, handleOnChange, onSelectAddress } = props;
  return (
    <>
      <PlacesAutocomplete
        value={addressInput}
        onChange={(address) => {
          handleOnChange({ target: { value: address, name: "addressLine1" } });
        }}
        onSelect={(address) => {
          geocodeByAddress(address)
            .then((results) => {
              onSelectAddress(results[0].address_components, {
                lat: results[0].geometry.location.lat(),
                long: results[0].geometry.location.lng(),
              });
            })
            .catch((error) => console.error("Error", error));
        }}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <Form.Control
              {...getInputProps({
                placeholder: "Enter Google Location/Locality",
                className: "location-search-input",
              })}
            />
            <div className="autocomplete-dropdown-container">
              {loading && <div>Loading Place Search Results...</div>}
              {addressInput !== "" &&
                addressInput &&
                suggestions.map((suggestion) => {
                  const className = suggestion.active
                    ? "suggestion-item--active p-2"
                    : "suggestion-item p-2";
                  const style = suggestion.active
                    ? { backgroundColor: "#fafafa", cursor: "pointer" }
                    : { backgroundColor: "#ffffff", cursor: "pointer" };
                  return (
                    <div
                      {...getSuggestionItemProps(suggestion, {
                        className,
                        style,
                      })}
                    >
                      <span>{suggestion.description}</span>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
      <Form.Text className="text-muted">
        For Example, R Block GK 1, also drag the pin in the map above to match
        the exact location
      </Form.Text>
    </>
  );
}
